import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import { getValueFromInput } from "util/FormsUtils";
import useProductName from "brand-customization/useProductName";
const PagerDutyNotificationForm = ({ config, validation, onChange }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u;
  const productName = useProductName();
  const { t } = useTranslation("integrations");
  const propagateChange = (key, value) => {
    const nextConfig = cloneDeep(config);
    if ((key === "pager_duty_title" || key === "incident_key") && value === "") {
      nextConfig[key] = null;
    } else {
      nextConfig[key] = value;
    }
    onChange(nextConfig);
  };
  const handleChange = (event) => {
    const { name } = event.target;
    propagateChange(name, getValueFromInput(event.target));
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-routing_key",
      name: "routing_key",
      label: t("pager_duty_notification_form.routing_key_label"),
      type: "text",
      bsStyle: validation.errors.routing_key ? "error" : null,
      help: (_c = (_b = (_a = validation.errors) == null ? void 0 : _a.routing_key) == null ? void 0 : _b[0]) != null ? _c : t("pager_duty_notification_form.routing_key_help"),
      value: config.routing_key,
      onChange: handleChange,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-pager_duty_title",
      name: "pager_duty_title",
      label: t("pager_duty_notification_form.incident_title_label"),
      type: "text",
      bsStyle: validation.errors.pager_duty_title ? "error" : null,
      help: (_f = (_e = (_d = validation.errors) == null ? void 0 : _d.pager_duty_title) == null ? void 0 : _e[0]) != null ? _f : t("pager_duty_notification_form.incident_title_help", { productName }),
      value: config.pager_duty_title,
      onChange: handleChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-custom_incident",
      name: "custom_incident",
      label: t("pager_duty_notification_form.custom_incident_label"),
      type: "checkbox",
      bsStyle: validation.errors.custom_incident ? "error" : null,
      help: (_i = (_h = (_g = validation.errors) == null ? void 0 : _g.custom_incident) == null ? void 0 : _h[0]) != null ? _i : t("pager_duty_notification_form.custom_incident_help"),
      checked: config.custom_incident,
      onChange: handleChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-key_prefix",
      name: "key_prefix",
      label: t("pager_duty_notification_form.key_prefix_label"),
      type: "text",
      bsStyle: validation.errors.key_prefix ? "error" : null,
      help: (_l = (_k = (_j = validation.errors) == null ? void 0 : _j.key_prefix) == null ? void 0 : _k[0]) != null ? _l : t("pager_duty_notification_form.key_prefix_help"),
      value: config.key_prefix,
      onChange: handleChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-incident_key",
      name: "incident_key",
      label: t("pager_duty_notification_form.incident_key_label"),
      type: "text",
      bsStyle: validation.errors.incident_key ? "error" : null,
      help: (_o = (_n = (_m = validation.errors) == null ? void 0 : _m.incident_key) == null ? void 0 : _n[0]) != null ? _o : t("pager_duty_notification_form.incident_key_help"),
      value: config.incident_key,
      onChange: handleChange
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-client_name",
      name: "client_name",
      label: t("pager_duty_notification_form.client_name_label"),
      type: "text",
      bsStyle: validation.errors.client_name ? "error" : null,
      help: (_r = (_q = (_p = validation.errors) == null ? void 0 : _p.client_name) == null ? void 0 : _q[0]) != null ? _r : t("pager_duty_notification_form.client_name_help", { productName }),
      value: config.client_name,
      onChange: handleChange,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "pagerduty-notification-v2-client_url",
      name: "client_url",
      label: t("pager_duty_notification_form.client_url_label"),
      type: "text",
      bsStyle: validation.errors.client_url ? "error" : null,
      help: (_u = (_t = (_s = validation.errors) == null ? void 0 : _s.client_url) == null ? void 0 : _t[0]) != null ? _u : t("pager_duty_notification_form.client_url_help", { productName }),
      value: config.client_url,
      onChange: handleChange,
      required: true
    }
  ));
};
export default PagerDutyNotificationForm;
